import { Component, OnInit } from "@angular/core";
import { Catalog } from "../../Model/Catalog/Catalog";
import { ModelService } from "../../Services/model.service";
import { TranslateService } from '@ngx-translate/core';
import { ClassificationSystem } from '../../Model/classification/ClassificationSystem';
import { UserManagementService } from "../../Services/userManagment.service";
import { ClassificationService } from "../../Services/classification.service";
import { lastValueFrom } from "rxjs";

@Component({
  selector: "catalogClassification",
  templateUrl: "catalogClassification.component.html",
  styleUrls: []
})
export class CatalogClassificationComponent implements OnInit {

  classificationSystems: ClassificationSystem[] = [];
  selectedClassificationSystemIds: string[] = [];

  constructor(
    public modelService: ModelService,
    public translate: TranslateService,
    public userManagement: UserManagementService,
    public classifcationService: ClassificationService
  ) { }

  get model(): Catalog {
    return this.modelService.catalogService.catalog;
  }

  async ngOnInit() {
    this.classificationSystems = await lastValueFrom(
      this.classifcationService.getClassificationSystemsForCustomer(
        this.modelService.loginService.currentUser.customerId,
        this.modelService.catalogService.catalog.language
      )
    );

    this.syncIdsFromModel();
  }

  onTagBoxChange(e: any) {
    this.syncModelFromIds();
    this.catalogChanged(e);
  }

  private syncIdsFromModel() {
    const items = this.model.classificationSystems ?? [];
    this.selectedClassificationSystemIds = items
      .map(cs => cs?.id)
      .filter(id => id !== null && id !== undefined);
  }

  private syncModelFromIds() {
    const idSet = new Set(this.selectedClassificationSystemIds);
    this.model.classificationSystems = (this.classificationSystems ?? []).filter(cs => idSet.has(cs.id));
  }

  catalogChanged(e: any) {
    this.modelService.catalogService.catalogChanged(e);
  }

  catalogUpdate(e: any = null) {
    this.modelService.catalogService.updateCatalog(e);
  }

  canView(name: string): boolean {
    return this.userManagement.canView(name);
  }

  readOnlyUser(name: string): boolean {
    return !this.userManagement.canEdit(name);
  }
}
